import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WildNudgeGameConfig} from "../../../WildNudgeGameConfig";
import {TweenLite, Power4, Linear, Back} from "gsap";

export class GearAnimView extends BaseView {

    private _gearWheelEaseInTween: TweenLite;
    private _gearWheelMainTween: TweenLite;
    private _gearWheelEaseOutTween: TweenLite;

    private static largerWheelRotVals: string[] = ["+=2 * Math.PI/180", "+=200 * Math.PI/180", "+=2 * Math.PI/180"];
    private static largerWheelRotValsQuick: string[] = ["+=2 * Math.PI/180", "+=200 * Math.PI/180", "+=0.4 * Math.PI/180"];
    private static smallWheelRotVals: string[] = ["-=5 * Math.PI/180", "-=450 * Math.PI/180", "-=5 * Math.PI/180"];
    private static smallWheelRotValsQuick: string[] = ["-=5 * Math.PI/180", "-=450 * Math.PI/180", "-= 0.99 * Math.PI/180"];

    private _gearWheel: PIXI.Sprite;
    private _gearWheel2: PIXI.Sprite;
    private _gearWheelShadow: PIXI.Sprite;
    private _gearWheel2Shadow: PIXI.Sprite;

    private _stopped: boolean = false;

    private _foregroundAnimationsLayer: PIXI.Container;

    constructor() {
        super();

        this._foregroundAnimationsLayer = StageManager.getLayer(WildNudgeGameConfig.instance.LAYERS.FORGROUND_ANIMATIONS.name);
    }

    protected initAnimations(): void {

        //gear wheel shadow for the bigger gear
        this._gearWheelShadow = new PIXI.Sprite(GameResources.getTextures("wheel1Shadow")[0]);
        this._gearWheelShadow.pivot.set(0.5 * this._gearWheelShadow.width, 0.5 * this._gearWheelShadow.height);
        this.addChild(this._gearWheelShadow);

        //gear wheel for the bigger gear
        this._gearWheel = new PIXI.Sprite(GameResources.getTextures("wheel1Shape")[0]);
        this._gearWheel.position.set(0.5 * this._gearWheel.width, 0.5 * this._gearWheel.height);
        this._gearWheel.pivot.set(0.5 * this._gearWheel.width, 0.5 * this._gearWheel.height);
        this.addChild(this._gearWheel);

        this._gearWheelShadow.position.set(this._gearWheel.position.x + 5, this._gearWheel.position.y + 5);

        //3D static effect
        let gearWheelThreeD: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("wheel13d")[0]);
        this.addChild(gearWheelThreeD);

        //gear wheel shadow for the smaller gear
        this._gearWheel2Shadow = new PIXI.Sprite(GameResources.getTextures("wheel2Shadow")[0]);
        this._gearWheel2Shadow.pivot.set(0.5 * this._gearWheel2Shadow.width, 0.5 * this._gearWheel2Shadow.height);
        this.addChild(this._gearWheel2Shadow);

        //gear wheel for the smaller gear
        this._gearWheel2 = new PIXI.Sprite(GameResources.getTextures("wheel2Shape")[0]);
        this._gearWheel2.position.set(93, 200);
        this._gearWheel2.pivot.set(0.5 * this._gearWheel2.width, 0.5 * this._gearWheel2.height);
        this.addChild(this._gearWheel2);

        this._gearWheel2Shadow.position.set(this._gearWheel2.position.x + 5, this._gearWheel2.position.y + 5);

        //3D static effect for the smaller gear
        let gearWheel2ThreeD: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("wheel23d")[0]);
        gearWheel2ThreeD.position.set(36, 140);
        this.addChild(gearWheel2ThreeD);

        this.position.set(95, 80);

        this._foregroundAnimationsLayer.addChild(this);
    }

    private playEaseInAnim(targ: any, rotTo: string[]): void {
        this._gearWheelEaseInTween = TweenLite.fromTo(targ, 0.5, {rotation: targ.rotation}, {
            rotation: rotTo[0],
            ease: Back.easeIn.config(3),
            onComplete: () => {
                if (!this._stopped)
                    this._gearWheelMainTween = TweenLite.fromTo(targ, 20, {rotation: targ.rotation}, {
                        rotation: rotTo[1],
                        ease: Linear.easeNone
                    });
            }, onCompleteParams: [targ, this, rotTo]
        });
    }

    private playEaseOutAnim(targ:any, dur:number, rotTo:string[]):void {
        if(!this._stopped)
            this._gearWheelEaseOutTween = TweenLite.fromTo(targ, dur,
                {
                    rotation: targ.rotation,
                },
                {
                    rotation: rotTo[2],
                    ease: Power4.easeOut
                },
            );
    }

    public startGearAnimation(): void {
        this.playEaseInAnim(this._gearWheel, GearAnimView.largerWheelRotVals);
        this.playEaseInAnim(this._gearWheelShadow, GearAnimView.largerWheelRotVals);
        this.playEaseInAnim(this._gearWheel2, GearAnimView.smallWheelRotVals);
    }

    public endGearAnimation(isQuick: boolean = false): void {
        if (!isQuick) {
            this.playEaseOutAnim(this._gearWheel, 1, GearAnimView.largerWheelRotVals);
            this.playEaseOutAnim(this._gearWheelShadow, 1, GearAnimView.largerWheelRotVals);
            this.playEaseOutAnim(this._gearWheel2, 1, GearAnimView.smallWheelRotVals);
        } else {
            this.playEaseOutAnim(this._gearWheel, 0.3, GearAnimView.largerWheelRotValsQuick);
            this.playEaseOutAnim(this._gearWheelShadow, 0.3, GearAnimView.largerWheelRotValsQuick);
            this.playEaseOutAnim(this._gearWheel2, 0.3, GearAnimView.smallWheelRotValsQuick);
        }
    }
}